import { gql } from "graphql-request";

const UploaderCompanyFeedQuery = gql`
  mutation UploaderCompanyFeed($input: CompanyFeedInput!) {
    UploaderCompanyFeed(input: $input) {
      status
      error
      messege
      data
    }
  }
`;
export default UploaderCompanyFeedQuery;
